import React from "react";
import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/js/bootstrap";
// import "jquery/dist/jquery";
// import "bootstrap/dist/css/bootstrap";
import config from "../config.json";

const NavBar = ({
  loggedIn,
  admin,
  showSearchInput,
  searchValue,
  onSearchChange,
  onCleanSearch,
}) => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light fixed-top "
      data-toggle="collapse"
      data-target=".navbar-collapse.show"
    >
      {/* <Link className="navbar-brand" to="/">
        <i
          className="fa fa-university fa-lg text-secondary mr-0"
          aria-hidden="true"
        ></i>
      </Link> */}
      <Link className="navbar-brand mt-2 justify-content-start" to="/">
        <div className="row">
          <i
            className="fa fa-university text-secondary fa-lg ml-3 mt-1"
            aria-hidden="true"
          ></i>
          <h3 className="justify-content-md-start text-secondary">UniNotas</h3>
        </div>
      </Link>

      {showSearchInput ? (
        <div className="md-form mt-0 col-3">
          <input
            id="input_search"
            value={searchValue}
            onChange={onSearchChange}
            className="form-control border-top-0 border-left-0 border-right-0 bg-light fa"
            placeholder="&#xf002;"
            type="text"
            aria-label="Search"
          />
          {/* <i
            className="fa fa-times text-secondary"
            aria-hidden="true"
            role="button"
            onClick={() => onCleanSearch()}
          /> */}
        </div>
      ) : null}

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div
        className="collapse navbar-collapse justify-content-end"
        id="navbarNav"
      >
        <div className="navbar-nav">
          {loggedIn ? (
            <NavLink className="nav-item nav-link font-weight-bold" to="/home">
              <i className="fa fa-bank" aria-hidden="true" />
              Home
            </NavLink>
          ) : null}
          {loggedIn ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/profile"
            >
              <i className="fa fa-user" aria-hidden="true" />
              Perfil
            </NavLink>
          ) : null}

          {loggedIn && admin ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to={"/institutes/form/new"}
            >
              <i className="fa fa-plus" aria-hidden="true" />
              Criar Instituto
            </NavLink>
          ) : null}

          <NavLink
            className="nav-item nav-link font-weight-bold"
            to="/howToUse"
          >
            <i className="fa fa-question" aria-hidden="true" />
            Como Usar
          </NavLink>
          <NavLink className="nav-item nav-link font-weight-bold" to="/about">
            <i className="fa fa-question-circle-o" aria-hidden="true" />
            {/* <i className="fa fa-user" aria-hidden="true" /> */}
            Sobre
          </NavLink>
          <li className="nav-item">
            <a
              className="nav-link font-weight-bold"
              target="_blank"
              rel="noopener noreferrer"
              href={config.terms_and_conditions_url}
            >
              <i className="fa fa-file-text-o" aria-hidden="true" />
              Termos e Condições <span className="sr-only">(current)</span>
            </a>
          </li>
          {/* {!loggedIn ? (
            <NavLink className="nav-item nav-link font-weight-bold" to="/login">
              Entrar
            </NavLink>
          ) : null} */}
          {loggedIn ? (
            <NavLink
              className="nav-item nav-link font-weight-bold"
              to="/logout"
            >
              <i className="fa fa-sign-out" aria-hidden="true" />
              Sair
            </NavLink>
          ) : null}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
